import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { interpret } from "xstate";
import calendarEventMachine from "./machines/calendarEventMachine";
import { CalendarEventModule } from "@/store/modules/calendarEvent.modules";
import EcGrid from "@/components/widgets/EcGrid.vue";
import DeleteComponent from "@/components/deleteComponent.vue";
import { RRule } from "rrule";
import { format } from "date-fns";
import { TextConverter } from "@/helpers/TextConverter";
Component.registerHooks(["metaInfo", "beforeRouteEnter"]);
let CalendarEventList = /** @class */ (() => {
    let CalendarEventList = class CalendarEventList extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Calendar Events";
            this.isGridLoading = false;
            this.initialPage = 1;
            this.initialPageSize = 10;
            this.totalCount = 0;
            this.activePopoverId = null;
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Calendar Events",
                    href: "#",
                },
            ];
            this.machine = calendarEventMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.serverParams = {
                columnFilters: {},
                sort: {
                    field: "title",
                    type: "none",
                },
                page: 1,
                pageSize: 10,
            };
            this.eventId = "";
            this.isPageIsDirty = false;
            this.columns = [
                {
                    field: "title",
                    label: "Event Title",
                    thClass: "event-title",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: "Enter event title",
                    },
                },
                {
                    field: "eventType",
                    label: "Event Type",
                    sortable: false,
                    thClass: "event-type",
                    tdClass: "",
                },
                {
                    field: "dueDateAsString",
                    label: "Due Date",
                    thClass: "",
                    sortable: true,
                    isDatePicker: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: "Select Date",
                    },
                },
                {
                    field: "state",
                    label: "State",
                    thClass: "",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: "Select State",
                        filterDropdownItems: [],
                    },
                },
                {
                    field: "actions",
                    label: "Actions",
                    thClass: "calendar-action",
                    sortable: false,
                },
            ];
            this.initialSortBy = {
                field: "dueDateAsString",
                type: "desc",
            };
            this.selectedDate = null;
        }
        send(event) {
            this.machineService.send(event);
        }
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        }
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        }
        onPerPageChange(params) {
            if (!this.isPageIsDirty) {
                this.initialPage = 1;
            }
            this.updateParams({
                pageSize: params.currentPerPage,
                page: this.initialPage,
            });
            this.loadItems();
        }
        onSortChange(params) {
            if (!this.isPageIsDirty) {
                this.initialPage = 1;
            }
            this.updateParams({ sort: params[0], page: this.initialPage });
            this.loadItems();
        }
        onColumnFilter(params) {
            if (!this.isPageIsDirty) {
                this.initialPage = 1;
            }
            this.updateParams({
                columnFilters: params.columnFilters,
                page: this.initialPage,
            });
            this.loadItems();
        }
        onDateChanged(item) {
            this.initialPage = 1;
            this.serverParams.page = this.initialPage;
            this.selectedDate = item;
            this.loadItems();
        }
        loadItems() {
            this.isGridLoading = true;
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            if (this.selectedDate != null) {
                filters.push({
                    name: "dueDate",
                    value: `${this.selectedDate}`,
                });
            }
            var searchData = {
                page: this.serverParams.page,
                pageSize: this.serverParams.pageSize,
                sort: this.serverParams.sort,
                columnFilters: filters,
            };
            CalendarEventModule.AssignSearchParams(searchData);
            this.machineService.send({
                type: "GETTING_CALENDAR_EVENT",
                searchData: searchData,
            });
        }
        editEvent(calendarEventId) {
            this.$router.push({ name: "EditCalendarEvent", params: { calendarEventId: calendarEventId } });
        }
        removeEvent(calendarEventId) {
            const isPageChanged = this.rows.length == 1 && this.serverParams.page != 1 ? true : false;
            this.eventId = calendarEventId;
            this.machineService.send({
                type: "DELETE_CALENDAR_EVENT",
                ispageChanged: isPageChanged,
            });
        }
        deleteCalendarEvent() {
            this.machineService.send({
                type: "DELETING_CALENDAR_EVENT",
                eventId: this.eventId,
            });
        }
        cancel() {
            this.send({
                type: "CANCEL",
            });
        }
        onRowClick() {
            return "";
        }
        clearFilter() {
            this.selectedDate = null;
            this.serverParams.columnFilters = {};
            var ecgrid = this.$refs.ecgrid;
            ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters = {};
            this.loadItems();
        }
        get rows() {
            return CalendarEventModule.calendarEvents;
        }
        get states() {
            return CalendarEventModule.states.map((x) => ({ value: x.id, text: x.value }));
        }
        get totalEvents() {
            return CalendarEventModule.totalCount;
        }
        get columnFilters() {
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            return filters;
        }
        get isAnyFilterApplied() {
            return this.columnFilters.length != 0 && this.columnFilters.some((x) => x.value);
        }
        async beforeRouteEnter(to, from, next) {
            if (from.name != "EditCalendarEvent") {
                CalendarEventModule.ClearSearchParams();
            }
            next();
        }
        initialize() {
            var value = CalendarEventModule.searchParams;
            if (value != null) {
                this.isPageIsDirty = true;
                this.initialPage = value.page;
                this.serverParams.pageSize = value.pageSize;
                if (value.columnFilters.length > 0) {
                    value.columnFilters.forEach((item) => {
                        this.serverParams.columnFilters[item.name] = item.value;
                    });
                }
                this.initialSortBy = value.sort;
            }
        }
        assignColumnFilters() {
            var ecgrid = this.$refs.ecgrid;
            var gridColumns = ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters;
            if (CalendarEventModule.searchParams && CalendarEventModule.searchParams.columnFilters.length > 0) {
                CalendarEventModule.searchParams.columnFilters.forEach((item) => {
                    this.isPageIsDirty = true;
                    if (item.name == "dueDate") {
                        this.selectedDate = item.value;
                    }
                    gridColumns[item.name] = item.value;
                });
            }
        }
        getFormattedRuleText(rule, startDate) {
            if (!rule)
                return "Invalid recurrence rule";
            try {
                const cleanRule = rule.replace(/\\n/g, "\n");
                let rrule = RRule.fromString(cleanRule);
                let ruleText = rrule.toText();
                const requiredWeekdays = [0, 1, 2, 3, 4];
                const selectedDays = rrule.options.byweekday || [];
                const isWeekdaysOnly = selectedDays.length === 5 && requiredWeekdays.every((day) => selectedDays.includes(day));
                var ruleValue = rrule.options;
                if (isWeekdaysOnly && ruleValue.byweekno) {
                    const weekNumber = ruleValue.byweekno;
                    let weekLabel = TextConverter.ordinalWords.find((w) => w.value.toString() === weekNumber)?.label || "";
                    if (ruleValue.freq === 1) {
                        let baseText = `every ${ruleValue.interval > 1 ? ruleValue.interval + " " : ""}${ruleValue.interval === 1 ? "month," : "months,"} on the ${weekLabel}Mon, ${weekLabel}Tue, ${weekLabel}Wed, ${weekLabel}Thu and ${weekLabel}Fri`;
                        // Add until/after information
                        if (ruleValue.until) {
                            const untilDate = new Date(ruleValue.until);
                            baseText += ` until ${format(untilDate, "MMM d, yyyy")}`;
                        }
                        else if (ruleValue.count > 0) {
                            baseText += ` after ${ruleValue.count} occurrences`;
                        }
                        ruleText = baseText + ".";
                    }
                }
                else if (isWeekdaysOnly) {
                    if (ruleValue.freq === 2) {
                        ruleText = ruleText.replace(/every weekday/g, "every week on weekdays");
                    }
                }
                if (ruleValue.interval == 1) {
                    ruleText = ruleText.replace(/every day/g, "every week on every day");
                }
                ruleText = TextConverter.removeDuplicateAndPhrase(ruleText);
                if (ruleValue.freq === 1 && ruleValue.bynmonthday.includes(-1)) {
                    ruleText = ruleText.replace(/last/g, "last date");
                }
                if (ruleValue.freq === 2) {
                    ruleText = ruleText.replace(/weeks days/g, "weeks on every day");
                }
                // Convert weekdays and months to short form
                ruleText = TextConverter.convertWeekdaysToShortForm(ruleText);
                ruleText = TextConverter.convertMonthsToShortForm(ruleText);
                return `${startDate} ${ruleText}`;
                return `${startDate} ${ruleText}`;
            }
            catch (error) {
                console.error("Error formatting rule:", error);
                return "Invalid recurrence rule";
            }
        }
        getOrdinalSuffix(day) {
            if (day > 3 && day < 21)
                return day + "th";
            switch (day % 10) {
                case 1:
                    return day + "st";
                case 2:
                    return day + "nd";
                case 3:
                    return day + "rd";
                default:
                    return day + "th";
            }
        }
        togglePopover(id) {
            if (this.activePopoverId === id) {
                this.activePopoverId = null;
            }
            else {
                this.activePopoverId = id;
            }
        }
        created() {
            this.initialize();
            this.machineService.start();
            this.machineService.onTransition((state) => {
                var previousState = this.state;
                this.state = state;
                if (previousState.matches("idle") && this.state.matches("gettingCalendarEvents")) {
                    this.assignColumnFilters();
                }
                if (this.state.matches("deletingCalendarEvent")) {
                    this.isGridLoading = true;
                }
                if (this.state.matches("loadedCalendarEvents")) {
                    var itemTypeColumn1 = this.columns.find((x) => x.field == "state");
                    if (itemTypeColumn1 && itemTypeColumn1.filterOptions.filterDropdownItems.length == 0) {
                        itemTypeColumn1.filterOptions.filterDropdownItems = this.states;
                    }
                    this.totalCount = this.totalEvents;
                    this.isGridLoading = false;
                    this.isPageIsDirty = false;
                }
                if (this.state.matches("gettingCalendarEvents") && previousState.matches("deletingCalendarEvent")) {
                    if (this.state.context.ispageChanged) {
                        this.serverParams.page = this.serverParams.page - 1;
                    }
                }
            });
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    CalendarEventList = __decorate([
        Component({
            name: "CalendarEvents",
            components: {
                Layout,
                PageHeader,
                Loader,
                EcGrid,
                DeleteComponent,
            },
        })
    ], CalendarEventList);
    return CalendarEventList;
})();
export default CalendarEventList;
